{
  "appVersion": "2026-11-04-develop-6703-e2e7a8f",
  "forceUpdate": false
}
